import React from "react";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import * as reportApi from "../../api/reportApi";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { toast } from "react-toastify";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";

class PrizeShare extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      years: [],
      year: new Date().getFullYear() - 1,
      member: "tff",
    };
  }

  async componentDidMount() {
    try {
      this.getYears();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getYears = () => {
    let lastYear = new Date().getFullYear() - 1;
    let years = [lastYear];

    for (let i = 1; i < 10; i++) {
      lastYear = lastYear - 1;
      years.push(lastYear);
    }
    years.sort((a, b) => b - a);
    this.setState({ years });
  };

  handleChange = async (e) => {
    const name = e.target.name;
    await this.setState({ [name]: e.target.value });
  };

  handledownload = async () => {
    const { member, year } = this.state;
    const excelfile = await reportApi.getExcelFilePrizeShare(
      member,
      year,
      true
    );
    if (excelfile === false) {
      toast.error("Ingen data");
    }
  };

  render() {
    return (
      <Container maxWidth="lg">
        <main style={{ width: "80%", paddingTop: 100, margin: "auto" }}>
          <Paper style={{ width: "100%", padding: 20 }}>
            <div style={{ height: 300 }}>
              <Grid container style={{ paddingTop: 50, marginLeft: 50 }}>
                <Grid item lg={12} style={{ marginLeft: 20 }}>
                  <h3>
                    Alle premieandeler i prosent for gitt organisasjon fram til
                    gitt år:
                  </h3>
                </Grid>
                <Grid item lg={4} style={{ paddingTop: 20 }}>
                  <FormControl variant="standard" style={{ minWidth: "70%", marginLeft: 20 }}>
                    <InputLabel>Organisasjon</InputLabel>
                    <Select
                      name="member"
                      value={this.state.member || ""}
                      onChange={this.handleChange}
                    >
                      <MenuItem value="tff">TFF</MenuItem>
                      <MenuItem value="yff">YFF</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={4} style={{ paddingTop: 20 }}>
                  <FormControl variant="standard" style={{ minWidth: "70%", marginLeft: 20 }}>
                    <InputLabel>År</InputLabel>
                    <Select
                      name="year"
                      value={this.state.year || ""}
                      onChange={this.handleChange}
                    >
                      {this.state.years &&
                        this.state.years.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={4} style={{ paddingTop: 20 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<CloudDownloadIcon />}
                    onClick={this.handledownload}
                    style={{ marginTop: 15, marginLeft: 20 }}
                  >
                    Vis i Excel
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Paper>
        </main>
      </Container>
    );
  }
}

export default PrizeShare;
